import { durationStandardWeb, easeEnter } from '@ingka/variables'

import { colourNeutralGrey100, colourNeutralGrey300 } from 'styles/tokens/oldSkapa.tokens'

import styled from 'styled-components'

import { StyledTableRowProps } from './CoachingSessionPreviewList.types'

export const TableCell = styled.td`
  vertical-align: middle;
  text-align: center;
`

export const TableRow = styled.tr<StyledTableRowProps>`
  transition: background-color ${easeEnter} ${durationStandardWeb};
  &:hover {
    background-color: ${colourNeutralGrey100};
  }
`

export const TableRowHeader = styled.tr`
  th {
    font-weight: bold;
  }
`

export const Dot = styled.span<{ color?: string }>`
  width: 0.4em;
  height: 0.4em;
  border-radius: 50%;
  border-style: solid;
  border-width: 0.45em;
  border-color: ${({ color }) => color ?? colourNeutralGrey300};
`
